// @ts-expect-error Untyped library
import { AuthTag } from '../modules/Doc/utils/DocsUtils';
export default AuthTag;